var formatProductIdBing = function formatProductIdBing(productId) {
  if (!productId) return '';
  var strProductId = String(productId);
  if (/^\d+$/.test(strProductId)) {
    var transformedProductId = strProductId.length === 8 ? "0".concat(strProductId) : strProductId;
    return "PLA-".concat(transformedProductId.substring(0, 7));
  }
  return "PLA-".concat(strProductId);
};
export default formatProductIdBing;